import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { MarkRequestReadState, ReadState } from '@atlassian/notification-types/types';
import { PositionInGroup } from '../../common/ui/avatar-thread';
import { triggerMarkNotificationGroup, triggerNotificationGroupExpanded, useCreateFireAnalyticsFromTrigger } from '../../common/utils/analytics';
import { ExpandedState, ExpandGroupButton } from './expand-group-button';
import { StyledNotificationItem, StyledNotificationItemSkeleton } from './styled';
import { calculateNotificationPositionInGroup, getSkeletonCount } from './utils';
var NotificationGroup = function NotificationGroup(_ref) {
  var notificationGroup = _ref.notificationGroup,
    listIndex = _ref.listIndex,
    onGroupNotificationsReadStateChange = _ref.onGroupNotificationsReadStateChange,
    onGroupExpanded = _ref.onGroupExpanded,
    onGroupReadStateChange = _ref.onGroupReadStateChange,
    emojiProvider = _ref.emojiProvider,
    mentionProvider = _ref.mentionProvider,
    onCommentCreatedFn = _ref.onCommentCreatedFn,
    isEligibleForBellNotifRepliesCtxExp = _ref.isEligibleForBellNotifRepliesCtxExp,
    profileIconUrl = _ref.profileIconUrl,
    userDisplayName = _ref.userDisplayName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  var fireGroupExpanded = useCreateFireAnalyticsFromTrigger(triggerNotificationGroupExpanded);
  var fireGroupMarked = useCreateFireAnalyticsFromTrigger(triggerMarkNotificationGroup);

  // TODO: This can be replaced with a loading state on the group
  var hasLoadedAllNotifications = notificationGroup.size === notificationGroup.notifications.length;
  var onExpand = function onExpand(listIndex) {
    return function () {
      // Collapse
      if (isExpanded && hasLoadedAllNotifications) {
        setExpanded(false);
        fireGroupExpanded('collapsed', notificationGroup, listIndex);
        return;
      }

      // Fetch more
      if (!hasLoadedAllNotifications) {
        onGroupExpanded(notificationGroup.id, notificationGroup.notificationContinuationToken);
      }
      setExpanded(true);
      fireGroupExpanded('expanded', notificationGroup, listIndex);
    };
  };
  var handleGroupToggleReadState = function handleGroupToggleReadState(listIndex) {
    return function (toState) {
      onGroupReadStateChange(notificationGroup.id, toState);
      fireGroupMarked(toState === ReadState.READ ? MarkRequestReadState.READ : MarkRequestReadState.UNREAD, notificationGroup, listIndex);
    };
  };
  var handleMarkBulkNotifications = function handleMarkBulkNotifications(notifications, toState) {
    var notificationIds = notifications.map(function (notification) {
      return notification.id;
    });
    onGroupNotificationsReadStateChange(notificationGroup.id, notificationIds, toState);
  };
  var numberOfSkeletons = getSkeletonCount(notificationGroup);
  if (isExpanded) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, notificationGroup.notifications.map(function (notification, index) {
      var positionInGroup = calculateNotificationPositionInGroup(index, notificationGroup);
      return /*#__PURE__*/React.createElement(StyledNotificationItem, {
        key: notification.id,
        notification: notification,
        listIndex: listIndex + 1,
        forceContentLoading: false,
        onGroupReadStateChange: handleGroupToggleReadState(listIndex),
        markBulkNotifications: handleMarkBulkNotifications,
        positionInGroup: positionInGroup,
        expandGroupButton: positionInGroup === PositionInGroup.LAST && /*#__PURE__*/React.createElement(ExpandGroupButton, {
          state: hasLoadedAllNotifications ? ExpandedState.Complete : ExpandedState.Open,
          onClick: onExpand(index)
        }),
        groupReadStates: notificationGroup.readStates,
        displayReadStateContextMenu: notificationGroup.size === 1 ? false : positionInGroup === PositionInGroup.FIRST,
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        onCommentCreatedFn: onCommentCreatedFn,
        isEligibleForBellNotifRepliesCtxExp: isEligibleForBellNotifRepliesCtxExp,
        profileIconUrl: profileIconUrl,
        userDisplayName: userDisplayName
      });
    }), notificationGroup.isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, _toConsumableArray(Array(numberOfSkeletons)).map(function (_, index) {
      return /*#__PURE__*/React.createElement(StyledNotificationItemSkeleton, {
        key: index,
        positionInGroup: index === numberOfSkeletons - 1 ? PositionInGroup.LAST : PositionInGroup.MIDDLE
      });
    })));
  }
  var notification = notificationGroup.notifications[0];
  return /*#__PURE__*/React.createElement(StyledNotificationItem, {
    notification: notification,
    listIndex: listIndex + 1,
    forceContentLoading: false,
    markBulkNotifications: handleMarkBulkNotifications,
    expandGroupButton: notificationGroup.size > 1 && /*#__PURE__*/React.createElement(ExpandGroupButton, {
      state: ExpandedState.Collapsed,
      onClick: onExpand(listIndex),
      actors: notificationGroup.additionalActors,
      notificationTypes: notificationGroup.additionalTypes,
      notificationCount: notificationGroup.size - 1
    }),
    displayReadStateContextMenu: notificationGroup.size > 1,
    onGroupReadStateChange: handleGroupToggleReadState(listIndex),
    groupReadStates: notificationGroup.readStates,
    emojiProvider: emojiProvider,
    mentionProvider: mentionProvider,
    onCommentCreatedFn: onCommentCreatedFn,
    isEligibleForBellNotifRepliesCtxExp: isEligibleForBellNotifRepliesCtxExp,
    profileIconUrl: profileIconUrl,
    userDisplayName: userDisplayName
  });
};
export default NotificationGroup;